import React from 'react';
import { __ } from '@wordpress/i18n';
import { Row, Col, Heading, P, Progress } from '../../ui/style';
import NextStepButton from '../util/next-step-button/next-step-button';
import PreviousStepLink from '../util/previous-step-link/index';
import NextStepLink from '../util/next-step-link/index';
import SquareSelect from '../square-select/square-select';
import styled from 'styled-components'

import { useStateValue } from '../../store/store';

const Wrap = styled.div`
	display: flex;
	height: 100vh;
`

const Left = styled.div`
	width: 350px;
    background: #fff;
    padding: 30px;
`

const Right = styled.div`
    padding: 30px;
	flex: 1;
`

const Customizer = ({ preview, controls }) => {
    const [{ currentIndex, stepsLength }, dispatch] = useStateValue();

    return (
        <Row className="row">
            <Col className="col left">
                <Progress value={currentIndex + 1} min="0" max={stepsLength} />
                {controls}

                <div className="ist-action-links">
                    <div className="ist-action-links-left">
                        <PreviousStepLink before='dashicons-arrow-left-alt'>{__('Back', 'astra-sites')}</PreviousStepLink>
                    </div>
                    <div className="ist-action-links-right">
                        <NextStepLink>{__('Skip', 'astra-sites')}</NextStepLink>
                    </div>
                </div>
            </Col>
            <Col className="col right">
                {preview}
            </Col>
        </Row>
    )
}

export default Customizer;
